import { ITaskNamespaces, IUserAvailabilityTypes } from 'types/graphqlTypes'
import { StringParam, BooleanParam, QueryParamConfigMap, ArrayParam } from 'use-query-params'
import { IAssignedToMeFilters } from './types'

export const ITEMS_PER_PAGE = 16

export const POLL_INTERVAL = 60 * 1000 * 30 // 30 minutes

export const TASK_NAMESPACE_LABEL = {
  [ITaskNamespaces.CE]: 'Tracking',
  [ITaskNamespaces.CX]: 'Scheduling',
}

export const TASK_TYPE_LABEL = {
  [IUserAvailabilityTypes.CeTaskAssignmentAvailability]: 'Tracking',
  [IUserAvailabilityTypes.CxTaskAssignmentAvailability]: 'Scheduling',
  [IUserAvailabilityTypes.CmLoadAssignmentAvailability]: '',
}

export const TASK_NAMESPACE_AVAILABILITY_MAP = {
  [ITaskNamespaces.CE]: IUserAvailabilityTypes.CeTaskAssignmentAvailability,
  [ITaskNamespaces.CX]: IUserAvailabilityTypes.CxTaskAssignmentAvailability,
}

export const TASK_AVAILABILITY_NAMESPACE_MAP = {
  [IUserAvailabilityTypes.CeTaskAssignmentAvailability]: ITaskNamespaces.CE,
  [IUserAvailabilityTypes.CxTaskAssignmentAvailability]: ITaskNamespaces.CX,
  [IUserAvailabilityTypes.CmLoadAssignmentAvailability]: null,
}

export const ASSIGNED_QUERY_CONFIG: Record<
  keyof IAssignedToMeFilters,
  QueryParamConfigMap[keyof QueryParamConfigMap]
> = {
  tasksPastDue: BooleanParam,
  searchTerm: StringParam,
  carrierIds: ArrayParam,
  shipperIds: ArrayParam,
  states: ArrayParam,
  pickupDate: StringParam,
  deliveryDate: StringParam,
  endPickupDate: StringParam,
  endDeliveryDate: StringParam,
  unread: BooleanParam,
  hot: BooleanParam,
  mustGo: BooleanParam,
  snoozed: BooleanParam,
}
